/** The content's valuation parameters (required capital, the multiple's ceiling and floor, the price model), from the round's preview context. The participant frame holds it; the solo run page has no frame, so it asks for the same context itself (same cache key, one fetch). */
import type { TeamState } from "@bsim/contracts";
import type { PreviewInput } from "@bsim/domain";
import { useRoute } from "../api/context";
import { usePreviewContext } from "../shell/PreviewProvider";

export type ValuationParams = PreviewInput["params"]["valuation"];

export function useValuationParams(team: TeamState | undefined): ValuationParams | undefined {
  const framed = usePreviewContext();
  const own = useRoute("getPreviewContext", framed !== undefined || team === undefined || team.round === null ? null : { teamId: team.team.id, roundId: team.round.id });
  return (framed ?? own.data)?.params.valuation;
}
